module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('h1', {
    staticClass: "tocheading"
  }, [_vm._v("Contents")])]), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Maps"
    }
  }, [_vm._v("List of Maps and Plates")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chronology"
    }
  }, [_vm._v("Chronology")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Part_one"
    }
  }, [_vm._v("PART ONE: THE COMING OF WAR")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter_01"
    }
  }, [_vm._v("1. Problems with the Pragmatica Sanctio")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Art of War in the Eighteenth Century")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The German Marshal –Maurice Saxe")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Billy the Martial Boy – Cumberland, the last Captain General")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Gallant Lieutenants – Löwendhal, Waldeck, Königseggand Ligonier")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Part_two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO: A MOST BLOODY BATTLE")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Tournai –the Great Fortresson the Scheldt")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. A Breaking-in Battle")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.The Infernal Column")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Luscious Sweets of Success, Bitter Fruits of Failure")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Part_three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE: HARD ROADS TOWARDS PEACE")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Jacobite Distraction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Treaty of Aix-la-Chapelle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Appendix_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1."), _c('span', {
    staticClass: "toc-sp"
  }, [_vm._v("Orders of Battle of the Armies at Fontenoy")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Appendix_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2."), _c('span', {
    staticClass: "toc-sp"
  }, [_vm._v("The Deposition of Brigadier General Richard Ingoldsby")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Appendix_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3."), _c('span', {
    staticClass: "toc-sp"
  }, [_vm._v("British Casualties at Fontenoy")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Footnote",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-505ff368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Toc.vue
// module id = 69
// module chunks = 0